import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../../../../constants/layout.mjs';
import { theme } from '../../../../../constants/theme.mjs';
"use strict";
const Container = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  justify-content: center;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    justify-content: unset;
  }
`;
const Buttons = styled.div`
  display: flex;
  background: #f4f5f6;
  border-radius: 8px;
  gap: 12px;
  width: fit-content;
  padding: 2px;
  margin-bottom: 24px;

  ${({
  $isSpotlight
}) => $isSpotlight && css`
      margin-right: 10px;
    `}
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #676f79;
  padding: 4px 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  ${({
  $isActive
}) => $isActive && css`
      background: ${theme.colors.white};
      color: ${theme.colors.primaryBlue};
    `}
`;
const ButtonCopy = styled.span`
  white-space: nowrap;
`;
export { Button, ButtonCopy, Buttons, Container };
//# sourceMappingURL=ButtonGroup.styles.mjs.map
